import { ActionTree, MutationTree } from "vuex";

export enum Status {
    none,
    running,
    success,
    failed
}

export enum SaveStatus {
    changed,
    saving,
    saved,
    failed
}

export interface IVtkFile {
    title: string;
    name: string;
    simpleTitle: string;
    relativePath: string;
}

export interface ISimulatorState {
    status: Status;
    log: string;
    saveStatus: SaveStatus;
    saveTimer?: number;
    results: Object | null;
    started_at: null | string;
    time_elapsed: number;
    is_valid_results: boolean;
    vtk_files: IVtkFile[];
}

export const initialState: ISimulatorState = {
    status: Status.none,
    log: "",
    saveStatus: SaveStatus.saved,
    results: null,
    started_at: null,
    time_elapsed: 0,
    is_valid_results: false,
    vtk_files: []
};

export const mutations: MutationTree<ISimulatorState> = {
    UPDATE_SAVE_TIMER(state, callback: () => void): void {
        clearTimeout(state.saveTimer);
        state.saveTimer = setTimeout(callback, 2000);
    },
    UPDATE_SAVE_STATUS(state, saveStatus: SaveStatus): void {
        state.saveStatus = saveStatus;
    },
    UPDATE_STATUS(state, status: Status): void {
        state.status = status;

        if (state.status === Status.success) {
            state.is_valid_results = true;
        }
    },
    UPDATE_LOG(state, log: string): void {
        state.log = log;
    },
    UPDATE_RESULTS(state, results): void {
        state.results = results;
    },
    UPDATE_STARTED_AT(state, startedAt: string | null): void {
        state.started_at = startedAt;
    },
    UPDATE_TIME_ELAPSED(state, timeElapsed: number): void {
        state.time_elapsed = timeElapsed;
    },
    UPDATE_VTK_FILES(state, vtkFiles: IVtkFile[]) {
        state.vtk_files = vtkFiles;
    }
};

export const actions: ActionTree<ISimulatorState, any> = {
    startSimulation({ commit }, request: Promise<void>): void {
        commit("UPDATE_STATUS", Status.running);
        commit("UPDATE_LOG", "");

        request.catch(({ response }) => {
            commit("UPDATE_STATUS", Status.failed);
            if (response.status !== 400) {
                commit("UPDATE_LOG", "Erro ao iniciar a simulação.");
            } else {
                let messages: string[] = [];
                for (const message of Object.values(
                    response.data
                ) as string[]) {
                    messages = [...messages, ...message];
                }
                commit("UPDATE_LOG", messages.join("\n"));
            }
        });
    }
};
